import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FilterData from "../components/FilterData.jsx";
import Buyers from "../pages/Buyers/Buyers";
import BuyersDetails from "../pages/Buyers/BuyersDetails";
import Closed from "../pages/Closed/Closed";
import Companies from "../pages/Companies/Companies";
import CompanyDetails from "../pages/Companies/CompanyDetails";
import ContactDetails from "../pages/Contacts/ContactDetails";
import Contacts from "../pages/Contacts/Contacts";
import AddContractToClosed from "../pages/ContractToClosed/AddContractToClosed";
import StageDetailPage from "../pages/ContractToClosed/components/StageDetailPage.jsx";
import ContractToClosed from "../pages/ContractToClosed/ContractToClosed";
import EditContractToClosed from "../pages/ContractToClosed/EditContractToClosed";
import Dashboard from "../pages/Dashboard/Dashboard";
import Exclusives from "../pages/Exclusive/Exclusives";
import ExecutedLOI from "../pages/Executed LOI/Executed.jsx";
import Leads from "../pages/Leads/Leads";
import ForgotPassword from "../pages/Login/ForgotPassword";
import Login from "../pages/Login/Login";
import NewPassword from "../pages/Login/NewPassword";
import OtpVerification from "../pages/Login/OtpVerification";
import PasswordChangeSuccess from "../pages/Login/PasswordChangeSuccess";
import Logs from "../pages/Logs/Logs.jsx";
import Profile from "../pages/MyProfile/Profile";
import SuperAdminProfile from "../pages/MyProfile/SuperAdminProfile";
import Offers from "../pages/Offers/Offers";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import Pipeline from "../pages/Pipeline/Pipeline.jsx";
import AddProperty from "../pages/Properties/AddProperty";
import EditProperty from "../pages/Properties/EditProperty";
import Properties from "../pages/Properties/Properties";
import PropertiesDemo from "../pages/Properties/PropertyDemo.jsx";
import PropertyDetails from "../pages/Properties/PropertyDetails";
import Proposals from "../pages/Proposals/Proposals";
import AddScorecard from "../pages/ScoreCard/AddScorecard.jsx";
import ScoreCardHistory from "../pages/ScoreCard/Component/ScoreCardHistory.jsx";
import ScoreCard from "../pages/ScoreCard/ScoreCard.jsx";
import BuyerArchive from "../pages/Settings/BuyerArchive";
import ClosedArchive from "../pages/Settings/ClosedArchive.jsx";
import CompanyArchive from "../pages/Settings/CompanyArchive";
import CompanyTag from "../pages/Settings/CompanyTag.jsx";
import ConnectedApp from "../pages/Settings/ConnectedApp";
import ContactArchive from "../pages/Settings/ContactArchive";
import ContactTag from "../pages/Settings/ContactTag";
import ContractToClosedArchive from "../pages/Settings/ContractToClosedArchive.jsx";
import ConversationRate from "../pages/Settings/ConverstionRate.jsx";
import DesignatedAgents from "../pages/Settings/DesignatedAgents";
import EXclusiveArchive from "../pages/Settings/ExclusiveArchive.jsx";
import ExecutedloiArchive from "../pages/Settings/ExecutedLOIAechive.jsx";
import LeadRoundRobin from "../pages/Settings/LeadRoundRobin.jsx";
import LeadSources from "../pages/Settings/LeadSources";
import LeadType from "../pages/Settings/LeaseType.jsx";
import Mailchimp from "../pages/Settings/Mailchimp.jsx";
import PropertyArchive from "../pages/Settings/PropertyArchive";
import PropertyTags from "../pages/Settings/PropertyTags";
import PropertyTypes from "../pages/Settings/PropertyTypes";
import StageDetailPageArchive from "../pages/Settings/StageDetailPageArchive.jsx";
import SystemAlerts from "../pages/Settings/SystemAlerts.jsx";
import Tenants from "../pages/Settings/Tenants";
import UnderContractArchive from "../pages/Settings/UnderContractArchive.jsx";
import CreateSmartPlan from "../pages/Smartplans/CreateSmartPlan";
import Smartplan from "../pages/Smartplans/Smartplan";
import Tasks from "../pages/Tasks/Tasks";
import UnderContract from "../pages/UnderContract/UnderContract";
import UserProfileDetail from "../pages/Users/UserProfileDetail";
import Users from "../pages/Users/Users";
import { ProtectedRoutes } from "./ProtectedRoutes";
import { PublicRoutes } from "./PublicRoutes";
import { ROUTES } from "./routeKeys";





const AppRoutes = () => {
  const userType = useSelector((state) => state.userType);

  return (
    <BrowserRouter>
      <Routes>

        {/* Public Routes (Login/Auth) */}
        <Route element={<PublicRoutes />}>
          <Route path={ROUTES.LOGIN} index element={<Login />} />
          <Route path={ROUTES.FORGOT_PASSWORD} index element={<ForgotPassword />} />
          <Route path={ROUTES.OTP_VERIFY} index element={<OtpVerification />} />
          <Route path={ROUTES.NEW_PASSWORD} index element={<NewPassword />} />
          <Route
            path={ROUTES.PASSWORD_SUCCESS}
            index
            element={<PasswordChangeSuccess />}
          />
        </Route>
      

        {/* Protected Routes  */}
        <Route element={<ProtectedRoutes />}>
          {(userType === 1 || userType === 2 || userType === 4) && (
            <Route path={ROUTES.USERS} index element={<Users />} />
          )}
          <Route path={ROUTES.DASHBOARD} index element={<Dashboard />} />
          <Route path={ROUTES.USER_DETAILS} index element={<UserProfileDetail />} />
          <Route path={ROUTES.CONTACTS} index element={<Contacts />} />
          <Route path={ROUTES.CONTACT_DETAILS} index element={<ContactDetails />} />
          <Route path={ROUTES.CONTACT_ACTION} index element={<ContactDetails />} />
          <Route path={ROUTES.COMPANIES} index element={<Companies />} />
          <Route path={ROUTES.COMPANY_DETAILS} index element={<CompanyDetails />} />
          <Route path={ROUTES.PROPERTIES} index element={<Properties />} />
          <Route path={ROUTES.PROPERTY_DETAILS} index element={<PropertyDetails />} />
          <Route path={ROUTES.ADD_PROPERTY} index element={<AddProperty />} />
          <Route path={ROUTES.EDIT_PROPERTY} index element={<EditProperty />} />
          <Route path={ROUTES.BUYERS} index element={<Buyers />} />
          <Route path={ROUTES.BUYER_DETAILS} index element={<BuyersDetails />} />
          <Route path={ROUTES.TASKS} index element={<Tasks />} />
          <Route path={ROUTES.TOUCH_PLANS} index element={<Smartplan />} />
          <Route path={ROUTES.TOUCH_PLAN_DETAILS} index element={<CreateSmartPlan />} />
          <Route path={ROUTES.LEADS} index element={<Leads />} />
          <Route path={ROUTES.PIPELINE} index element={<Pipeline />} />
          <Route path={ROUTES.EXECUTED_LOI} index element={<ExecutedLOI />} />
          <Route path={ROUTES.PROPOSALS} index element={<Proposals />} />
          <Route path={ROUTES.SCORE_CARD} index element={<ScoreCard />} />
          <Route path={ROUTES.SCORE_CARD_HISTORY} index element={<ScoreCardHistory />} />
          <Route path={ROUTES.OFFERS} index element={<Offers />} />
          <Route path={ROUTES.EXCLUSIVES} index element={<Exclusives />} />
          <Route path={ROUTES.PROPERTY_DEMO} index element={<PropertiesDemo />} />
          <Route path={ROUTES.UNDER_CONTRACT} index element={<UnderContract />} />
          <Route path={ROUTES.CLOSED} index element={<Closed />} />
          <Route path={ROUTES.STAGE_DETAILS} index element={<StageDetailPage />} />
          <Route path={ROUTES.STAGE_DETAILS_ARCHIVE} index element={<StageDetailPageArchive />} />
          <Route path={ROUTES.CONTACT_CLOSE} index element={<ContractToClosed />} />
          <Route path={ROUTES.FILTER_DATA} index element={<FilterData />} />
          <Route
            path={ROUTES.ADD_CONTACT_CLOSE}
            index
            element={<AddContractToClosed />}
          />
          <Route
            path={ROUTES.ADD_SCORE_CARD}
            index
            element={<AddScorecard />}
          />
          <Route
            path={ROUTES.EDIT_CONTACT_CLOSE}
            index
            element={<EditContractToClosed />}
          />

          {/* Settings Routes */}
          <Route
            path={ROUTES.SETTINGS.CONTACT_ARCHIVE}
            index
            element={<ContactArchive />}
          />
          <Route
            path={ROUTES.SETTINGS.COMPANY_ARCHIVE}
            index
            element={<CompanyArchive />}
          />
          <Route
            path={ROUTES.SETTINGS.CONTRACT_TO_CLOSED_ARCHIVE}
            index
            element={<ContractToClosedArchive />}
          />
           <Route
            path={ROUTES.SETTINGS.LOGS}
            index
            element={<Logs />}
          />
          <Route
            path={ROUTES.SETTINGS.PROPERTY_ARCHIVE}
            index
            element={<PropertyArchive />}
          />
          <Route
            path={ROUTES.SETTINGS.BUYER_ARCHIVE}
            index
            element={<BuyerArchive />}
          />
          <Route
            path={ROUTES.SETTINGS.EXECUTED_LOI_ARCHIVE}
            index
            element={<ExecutedloiArchive />}
          />
          <Route
            path={ROUTES.SETTINGS.EXCLUSIVE_ARCHIVE}
            index
            element={<EXclusiveArchive />}
          />
          <Route
            path={ROUTES.SETTINGS.UNDER_CONTRACT_ARCHIVE}
            index
            element={<UnderContractArchive />}
          />
          <Route
            path={ROUTES.SETTINGS.CLOSED_ARCHIVE}
            index
            element={<ClosedArchive />}
          />
          <Route path={ROUTES.SETTINGS.CONTACT_TAGS} index element={<ContactTag />} />
          <Route path={ROUTES.SETTINGS.COMPANY_TAGS} index element={<CompanyTag />} />
          <Route
            path={ROUTES.SETTINGS.LEAD_SOURCES}
            index
            element={<LeadSources />}
          />

           <Route
            path={ROUTES.SETTINGS.LEAD_TYPE}
            index
            element={<LeadType />}
          />
            <Route
            path={ROUTES.SETTINGS.LEAD_ROUND_ROBIN}
            index
            element={<LeadRoundRobin />}
          />
          <Route
            path={ROUTES.SETTINGS.DESIGNATED_AGENTS}
            index
            element={<DesignatedAgents />}
          />
          <Route
            path={ROUTES.SETTINGS.PROPERTY_TYPES}
            index
            element={<PropertyTypes />}
          />
           <Route
            path={ROUTES.SETTINGS.CONVERSION_RATE}
            index
            element={<ConversationRate />}
          />
          <Route
            path={ROUTES.SETTINGS.PROPERTY_TAGS}
            index
            element={<PropertyTags />}
          />
          <Route path={ROUTES.SETTINGS.TENANTS} index element={<Tenants />} />
          <Route path={ROUTES.SETTINGS.MAILCHIMP} index element={<Mailchimp />} />
          <Route
            path={ROUTES.SETTINGS.CONNECTED_APP}
            index
            element={<ConnectedApp />}
          />
          <Route
            path={ROUTES.SETTINGS.SYSTEM_ALERTS}
            index
            element={<SystemAlerts />}
          />
          <Route
            path={ROUTES.SETTINGS.PROFILE}
            index
            element={userType === 1 ? <SuperAdminProfile /> : <Profile />}
          />
        </Route>

          <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
